import axios from "axios";
import React, { useEffect, useState } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Swal from "sweetalert2";
import { baseUrl, userName, ipAddress } from "./Univ.js";

function AddVoter() {
  const [houses, setHouses] = useState([]);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [form, setForm] = useState({
    house: "",
    name: "",
    age: "",
    gender: "",
    voter_id: "",
    support_level: "3",
    addedby: userName,
    ip_add: ipAddress
  });

  /* ---------------- HANDLE CHANGE ---------------- */
  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  /* ---------------- FORM SUBMIT ---------------- */
  const formSubmit = () => {
    if (!form.house || !form.name) {
      Swal.fire("Error", "House & Name are required", "error");
      return;
    }

    const _formData = new FormData();
    _formData.append("house", form.house);
    _formData.append("name", form.name);
    _formData.append("age", form.age);
    _formData.append("gender", form.gender);
    _formData.append("voter_id", form.voter_id);
    _formData.append("support_level", form.support_level);
    _formData.append("addedby", userName);
    _formData.append("ip_add", ipAddress);

    axios
      .post(baseUrl + "voters/", _formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          Swal.fire({
            title: "Voter has been added",
            icon: "success",
            timer: 3000,
            showConfirmButton: false
          });
          setTimeout(() => window.location.reload(), 1000);
          setForm({
            house: "",
            name: "",
            age: "",
            gender: "",
            voter_id: "",
            support_level: "3",
            addedby: userName,
            ip_add: ipAddress
          });
        }
      })
      .catch((error) => {
        console.error(error.response?.data || error);
        Swal.fire("Error", "Failed to add voter", "error");
      });
  };

  /* ---------------- FETCH DATA ---------------- */
  const fetchVoters = () => {
    setIsLoading(true);
    axios.get(baseUrl + "voters/")
      .then(res => {
        setRows(res.data);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  };

  const fetchHouses = () => {
    axios.get(baseUrl + "houses/")
      .then(res => setHouses(res.data))
      .catch(err => console.log(err));
  };

  useEffect(() => {
    fetchHouses();
    fetchVoters();
  }, []);

  /* ---------------- DATAGRID COLUMNS ---------------- */
  const columns = [
    { field: "id", headerName: "ID", width: 80 },

    {
      field: "house",
      headerName: "House No",
      width: 150,
      renderCell: (params) =>
        params?.row?.house?.house_no || "—"
    },

    { field: "name", headerName: "Name", width: 180 },
    { field: "age", headerName: "Age", width: 100 },
    { field: "gender", headerName: "Gender", width: 120 },
    { field: "voter_id", headerName: "Voter ID", width: 150 },

    {
      field: "support_level",
      headerName: "Support",
      width: 140,
      renderCell: (params) => {
        if (params.value == 1) return "Against";
        if (params.value == 3) return "Neutral";
        if (params.value == 5) return "Supporter";
        return "-";
      }
    },
    {
  field: "actions",
  headerName: "Actions",
  width: 130,
  renderCell: (params) => (
    <button
      className="btn btn-danger btn-sm"
      onClick={() => handleDelete(params.row.id)}
    >
      Delete
    </button>
  ),
}

  ];
/* ---------------- DELETE ---------------- */
const handleDelete = (id) => {
  Swal.fire({
    title: "Confirm",
    text: "Delete this voter?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Delete",
  }).then((result) => {
    if (result.isConfirmed) {
      axios
        .delete(baseUrl + "delete-voters/" + id + "/")
        .then(() => {
          Swal.fire("Deleted", "Voter removed", "success");
          fetchVoters();
        })
        .catch((err) => {
          console.error(err);
          Swal.fire("Error", "Failed to delete voter", "error");
        });
    }
  });
};

  return (
    <section className="container mt-4">
      <div className="card">
        <h4 className="card-header">Add Voter</h4>

        <div className="card-body">
          {/* House */}
          <div className="mb-3">
            <label className="form-label">House</label>
            <select
              className="form-control"
              name="house"
              value={form.house}
              onChange={handleChange}
            >
              <option value="">-- Select House --</option>
              {houses.map((h) => (
                <option key={h.id} value={h.id}>
                  {h.house_no}
                </option>
              ))}
            </select>
          </div>

          {/* Name */}
          <div className="mb-3">
            <label className="form-label">Voter Name</label>
            <input
              type="text"
              name="name"
              value={form.name}
              onChange={handleChange}
              className="form-control"
            />
          </div>

          {/* Age */}
          <div className="mb-3">
            <label className="form-label">Age</label>
            <input
              type="number"
              name="age"
              value={form.age}
              onChange={handleChange}
              className="form-control"
            />
          </div>

          {/* Gender */}
          <div className="mb-3">
            <label className="form-label">Gender</label>
            <select
              name="gender"
              value={form.gender}
              onChange={handleChange}
              className="form-control"
            >
              <option value="">-- Select --</option>
              <option value="M">Male</option>
              <option value="F">Female</option>
              <option value="T">Third Gender</option>
            </select>
          </div>

          {/* Voter ID */}
          <div className="mb-3">
            <label className="form-label">Voter ID</label>
            <input
              type="text"
              name="voter_id"
              value={form.voter_id}
              onChange={handleChange}
              className="form-control"
            />
          </div>

          {/* Support Level */}
          <div className="mb-3">
            <label className="form-label">Support Level</label>
            <select
              name="support_level"
              value={form.support_level}
              onChange={handleChange}
              className="form-control"
            >
              <option value="1">Strong Against</option>
              <option value="3">Neutral</option>
              <option value="5">Strong Supporter</option>
            </select>
          </div>

          <button className="btn btn-primary" onClick={formSubmit}>
            Save Voter
          </button>
        </div>
      </div>

      {/* DataGrid */}
      <div className="mt-4">
        <DataGrid
          rows={rows}
          columns={columns}
          loading={isLoading}
          pageSize={25}
          rowsPerPageOptions={[25, 50, 100]}
          components={{ Toolbar: GridToolbar }}
          autoHeight
          sx={{
            boxShadow: 4,
            border: 4,
            borderColor: "primary.light",
            "& .MuiDataGrid-cell:hover": {
              color: "primary.main"
            }
          }}
        />
      </div>
    </section>
  );
}

export default AddVoter;
